// Auto-generated per-query builders for Unit
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { UnitReadAPI, UnitWriteAPI, UnitReadAPISchema, UnitWriteAPISchema } from '../types/unit';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, CatalogAt, HasAttribute, HasAttributeValue, HasDerivedValue, IslandHoldsPin, Mentions, NumericAttributeHasCanonicalUnit, UnitInWorkspace } from '../../relationships/relationship';

import { SecurityScope } from '../../shared/api/securityscope';
import { Workspace } from '../../base/api/workspace';
import { NumericAttribute } from './numericattribute';
import { Attribute } from './attribute';
import { AttributeValue } from './attributevalue';
import { DerivedValue } from './derivedvalue';
import { Expression } from './expression';
import { IslandPin } from './islandpin';





// Builder chain for query: rflp-unit-by-id

export interface RflpUnitByIdBuilder_0 {
  get(id: string): RflpUnitByIdBuilder_1;
  filter(conditions: { id: string }): RflpUnitByIdBuilder_1;
}

export interface RflpUnitByIdBuilder_1 {
  all(): Promise<Unit[]>;
  first(): Promise<Unit | null>;
  get(): Promise<Unit[]>;
  execute(): Promise<Unit[]>;
}


// Union of all query entry points
export type UnitQueryBuilder = RflpUnitByIdBuilder_0;

// Available query names for .setQuery()
export type UnitQueryNames = "rflp-unit-by-id";

// Type narrowing for .setQuery()
export type UnitBuilderForQuery<Q extends UnitQueryNames> =
  Q extends "rflp-unit-by-id" ? RflpUnitByIdBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type UnitInstanceQueryResult<Q extends UnitQueryNames> =
  Q extends "rflp-unit-by-id" ? RflpUnitByIdBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'rflp-unit-by-id',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends UnitQueryNames>(queryName: Q): UnitBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface Unit extends Partial<UnitReadAPI> {}
export class Unit extends NeoNodeBase<UnitReadAPI, UnitWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "Unit";
  static readonly readSchema = UnitReadAPISchema;
  static readonly writeSchema = UnitWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    catalog_scope: { target: "SecurityScope", cardinality: "one", isParent: false, relClass: "CatalogAt", direction: "out" },
    workspace: { target: "Workspace", cardinality: "one", isParent: false, relClass: "UnitInWorkspace", direction: "out" },
    canonical_for_numeric_attributes: { target: "NumericAttribute", cardinality: "many", isParent: false, relClass: "NumericAttributeHasCanonicalUnit", direction: "in" },
    attributes: { target: "Attribute", cardinality: "many", isParent: false, relClass: "HasAttribute", direction: "out" },
    attribute_values: { target: "AttributeValue", cardinality: "many", isParent: false, relClass: "HasAttributeValue", direction: "out" },
    derived_values: { target: "DerivedValue", cardinality: "many", isParent: false, relClass: "HasDerivedValue", direction: "out" },
    mentioned_in_expressions: { target: "Expression", cardinality: "many", isParent: false, relClass: "Mentions", direction: "in" },
    island_pins: { target: "IslandPin", cardinality: "many", isParent: false, relClass: "IslandHoldsPin", direction: "out" },
  };

  protected get modelName(): string {
    return 'Unit';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return Unit.label;
  }


  constructor(data: Partial<UnitWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: UnitReadAPI, loadContext?: Record<string, any>): Unit {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { catalog_scope, security_scope, workspace, canonical_for_numeric_attributes, attributes, attribute_values, derived_values, mentioned_in_expressions, island_pins, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = UnitReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, catalog_scope: catalog_scope, security_scope: security_scope, workspace: workspace, canonical_for_numeric_attributes: canonical_for_numeric_attributes, attributes: attributes, attribute_values: attribute_values, derived_values: derived_values, mentioned_in_expressions: mentioned_in_expressions, island_pins: island_pins };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return Unit.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'catalog_scope', 'SecurityScope', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadOneRelationship(processed, 'workspace', 'Workspace', ModelRegistry);
    loadManyRelationship(processed, 'canonical_for_numeric_attributes', 'NumericAttribute', ModelRegistry);
    loadManyRelationship(processed, 'attributes', 'Attribute', ModelRegistry);
    loadManyRelationship(processed, 'attribute_values', 'AttributeValue', ModelRegistry);
    loadManyRelationship(processed, 'derived_values', 'DerivedValue', ModelRegistry);
    loadManyRelationship(processed, 'mentioned_in_expressions', 'Expression', ModelRegistry);
    loadManyRelationship(processed, 'island_pins', 'IslandPin', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new Unit(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): UnitQueryBuilder {
    return new QueryBuilderImpl('Unit').filter(conditions) as any;
  }

  static all(): UnitQueryBuilder {
    return new QueryBuilderImpl('Unit') as any;
  }

  static async first(): Promise<Unit | null> {
    const results = await new QueryBuilderImpl('Unit').execute();
    return results[0] || null;
  }


  static setQuery<Q extends UnitQueryNames>(queryName: Q): UnitBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('Unit');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends UnitQueryNames>(queryName: Q): UnitInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = Unit.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'catalog_scope' - Python ORM style (cached)
  get catalog_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('catalog_scope', () => {
      return new RelationshipManager(this, 'catalog_scope', 'one', CatalogAt as typeof Relationship);
    });
  }

  // Relationship manager for 'workspace' - Python ORM style (cached)
  get workspace(): RelationshipManager<this, Workspace> {
    return this.getOrCreateRelationshipManager('workspace', () => {
      return new RelationshipManager(this, 'workspace', 'one', UnitInWorkspace as typeof Relationship);
    });
  }

  // Relationship manager for 'canonical_for_numeric_attributes' - Python ORM style (cached)
  get canonical_for_numeric_attributes(): RelationshipManager<this, NumericAttribute> {
    return this.getOrCreateRelationshipManager('canonical_for_numeric_attributes', () => {
      return new RelationshipManager(this, 'canonical_for_numeric_attributes', 'many', NumericAttributeHasCanonicalUnit as typeof Relationship);
    });
  }

  // Relationship manager for 'attributes' - Python ORM style (cached)
  get attributes(): RelationshipManager<this, Attribute> {
    return this.getOrCreateRelationshipManager('attributes', () => {
      return new RelationshipManager(this, 'attributes', 'many', HasAttribute as typeof Relationship);
    });
  }

  // Relationship manager for 'attribute_values' - Python ORM style (cached)
  get attribute_values(): RelationshipManager<this, AttributeValue> {
    return this.getOrCreateRelationshipManager('attribute_values', () => {
      return new RelationshipManager(this, 'attribute_values', 'many', HasAttributeValue as typeof Relationship);
    });
  }

  // Relationship manager for 'derived_values' - Python ORM style (cached)
  get derived_values(): RelationshipManager<this, DerivedValue> {
    return this.getOrCreateRelationshipManager('derived_values', () => {
      return new RelationshipManager(this, 'derived_values', 'many', HasDerivedValue as typeof Relationship);
    });
  }

  // Relationship manager for 'mentioned_in_expressions' - Python ORM style (cached)
  get mentioned_in_expressions(): RelationshipManager<this, Expression> {
    return this.getOrCreateRelationshipManager('mentioned_in_expressions', () => {
      return new RelationshipManager(this, 'mentioned_in_expressions', 'many', Mentions as typeof Relationship);
    });
  }

  // Relationship manager for 'island_pins' - Python ORM style (cached)
  get island_pins(): RelationshipManager<this, IslandPin> {
    return this.getOrCreateRelationshipManager('island_pins', () => {
      return new RelationshipManager(this, 'island_pins', 'many', IslandHoldsPin as typeof Relationship);
    });
  }

}
